import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";
import ComponentContainer from "../../layouts/component-container";
import { Widgets } from "../../widgets";

import { componentProps, getSlotId } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./tenStories2AdWithLoadMore.m.css";

const TenStories2AdWithLoadMore = ({ collection, lang }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { mobile, desktop, tab } = useDevice();
  const {
    widgetUrl,
    widgetDesktopHeight = 500,
    widgetMobileHeight = 500,
    items = [],
    adSlot1,
    adSlot2,
    layoutName,
    showCollectionName,
    numberOfCollectionsToShow,
    numberOfStoriesSkipToShow = 0,
  } = componentProps(collection);

  if (!items.length) return null;

  let childCollection;
  const showChild = numberOfCollectionsToShow === 1;

  if (showChild) {
    childCollection = items.find(({ type }) => type === "collection");
  }

  if (showChild && !childCollection) return null;

  const styles = {
    "--current-widget-mobile-height": widgetMobileHeight ? widgetMobileHeight + "px" : undefined,
    "--current-widget-desktop-height": widgetDesktopHeight ? widgetDesktopHeight + "px" : undefined,
  };

  const collectionSlug = showCollectionName ? collection?.slug : childCollection?.slug;

  const widget = widgetUrl && (
    <div styleName="widget">
      <Widgets widgetUrl={widgetUrl} widgetHeight={mobile ? widgetMobileHeight : widgetDesktopHeight} />
    </div>
  );

  return (
    <ComponentContainer collection={showCollectionName ? collection : childCollection} styleName="base">
      <div styleName="wrapper">
        <div styleName="empty-div" />
        <Organism1
          numberOfStoriesSkipToShow={numberOfStoriesSkipToShow}
          collection={showChild ? childCollection : collection}
          adSlot1={adSlot1}
          lang={lang}
          widget={(mobile || tab) && widget}
        />
        <div styleName="widget-and-ad" style={styles}>
          <DfpContainer>
            <div styleName="ad-slot" className="adsBox">
              <DfpComponent
                type={adSlot2}
                slotId={getSlotId(adSlot2, collectionSlug, 2)}
                collectionSlug={collectionSlug}
                layoutName={layoutName}
              />
            </div>
          </DfpContainer>
          {desktop && widget}
        </div>
      </div>
    </ComponentContainer>
  );
};

TenStories2AdWithLoadMore.propTypes = {
  collection: object,
  lang: string,
};

TenStories2AdWithLoadMore.storyLimit = 30;
TenStories2AdWithLoadMore.nestedCollectionLimit = [30];

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(TenStories2AdWithLoadMore);
